import {ERROR, LOADING, SUCCESS, CLEAR} from "./mutation-types";
import {Errors} from "./../util/Errors";

export const NO_ERROR = Symbol(0);
export const FORM_ERROR = Symbol(1);
export const GENERAL_ERROR = Symbol(2);

export const commonState = () => ({
    success:false,
    error:false,
    error_type:NO_ERROR,
    loading:false,
    errors:new Errors(),
})

export const commonMutations = {
    [SUCCESS]:(state)=>{
        state.success = true;
        state.loading = false
        state.errors.clear();
    },
    [ERROR]:(state, error)=>{
        state.success = false;
        state.loading = false;
        state.errors.clear();
        state.error_type = NO_ERROR;
        if(error.response) {
            if(error.response.status===422){
                state.errors.record(error.response.data.errors);
                state.error_type = FORM_ERROR;
            }else {
                state.error_type = GENERAL_ERROR;
                state.error = error.response.data.message;
            }
        }else{
            if(error.message)
                state.error = error.message;
            else state.error = error;
        }
    },
    [LOADING]:(state, ld)=>{
        state.loading = ld;
    },
    [CLEAR]:(state)=>{
        state.success = false;
        state.errors.clear();
        state.error = false;
    },
}

export function getCrudApiActions(stateField, api, parentStore) {
    return {
        async save({ dispatch, commit, state, rootGetters }){
            if(!state[stateField].id) {
                try {
                    commit(CLEAR);
                    commit(LOADING, true);
                    let item = await api.create(state[stateField], rootGetters['account/token'], rootGetters['account/companyId']);
                    commit(parentStore+'/push', item, {root: true});
                    commit('edit', item);
                    commit(SUCCESS);
                } catch (error) {
                    commit(ERROR, error);
                }
            }else{
                await dispatch('update', state[stateField]);
            }
        },
        async update({ commit, rootGetters }, editedItem){
            try{
                commit(CLEAR);
                commit(LOADING, true);
                let item = await api.edit(editedItem, rootGetters['account/token'], rootGetters['account/companyId']);
                commit(parentStore+'/replace', item, { root: true });
                commit('edit', item);
                commit(SUCCESS);
            } catch (error) {
                console.log(error)
                commit(ERROR, error);
            }
        },
        async delete({ commit, state, rootGetters }){
            try{
                commit(CLEAR);
                commit(LOADING, true);
                let success =  await api.delete(state[stateField], rootGetters['account/token'], rootGetters['account/companyId']);
                if(success) {
                    commit(parentStore+'/delete', state[stateField], {root: true});
                    commit(SUCCESS);
                    commit('reset')
                }else{
                    commit(ERROR, "Error deleting "+stateField+".");
                }
            }catch(error){
                commit(ERROR, error);
            }
        },
        async edit({ commit, rootGetters }, id){
            try{
                commit(CLEAR);
                commit(LOADING, true);
                let item = await api.find(id, rootGetters['account/token'], rootGetters['account/companyId'])
                commit('edit', item);
                commit(SUCCESS);
            } catch (error) {
                commit(ERROR, error.message);
            }
        }
    }
}

export function crudMutations(attrName, useDataWrapper=false){
    let getStateData = (state, attrName, useDataWrapper)=> (useDataWrapper ? state.data : state)[attrName]
    return {
        ...commonMutations,
        push:(state, item)=>{
            getStateData(state, attrName, useDataWrapper).push(item)
        },
        replace:(state, item)=>{
            let index = getStateData(state, attrName, useDataWrapper).findIndex(t=>t.id===item.id);
            getStateData(state, attrName, useDataWrapper).splice(index, 1, item);
        },
        delete:(state, item)=>{
            let index = getStateData(state, attrName, useDataWrapper).findIndex(t=>t.id===item.id);
            getStateData(state, attrName, useDataWrapper).splice(index, 1);
        },
        update:(state, list)=>{
            state[attrName] = list;
            if(!!useDataWrapper){
                state[attrName].updateData(list)
            }else{
                state[attrName] = list;
            }
        },
    }
}

export function getCrudMutations(stateField, compareField='id') {
    return {
        push:(state, item)=>{
            state[stateField].data.push(item)
        },
        replace:(state, item)=>{
            let index = state[stateField].data.findIndex(t=>t[compareField]===item[compareField]);
            state[stateField].data.splice(index, 1, item);
        },
        delete:(state, item)=>{
            let index = state[stateField].data.findIndex(t=>t[compareField]===item[compareField]);
            state[stateField].data.splice(index, 1);
        },
        update:(state, list)=>{
            state[stateField] = state[stateField].updateData(list)
        },
    }
}

export function apiAction(runnable){
    return async (...args)=>{
        args = Array.from(args);
        let { commit } = args[0];
        try{
            commit(LOADING, true);
            await runnable(...args);
            commit(SUCCESS);
        } catch (error) {
            console.error(error);
            commit(ERROR, error.message);
        }
    }
}